<template>
  <div id="app">
    <div v-if="!loading">
      <h2 class="headline">{{ settings.headline }}</h2>
      <div v-if="settings.image_id" class="image">
        <img v-bind:src="getPolopolyImgUrl(settings.image_id, 'media_in_article_large_original')" width="100%">
        <div class="image_caption">{{ settings.image_caption }}</div>
      </div>
<!--       <span class="flag-icon flag-icon-de"></span>
      <span class="flag-icon flag-icon-gr flag-icon-squared"></span> -->
      <p class="subheadline">{{ settings.subheadline }}</p>
      <div class="accordion">
        <toggleItem v-for="(region, i) in europa" :region="region"></toggleItem>
      </div>
     
      <!-- <div class="accordion">
        <toggleItem v-for="(region, i) in europa" :region="region"></toggleItem>
      </div> -->
      <!-- <table>
        <thead>
          <tr>
            <td> </td>
            <td><span>Einreise</span></td>
            <td><span>Restaurants, Cafés</span></td>
            <td><span>Hotels, Pensionen</span></td>
            <td><span>Ferien-wohnungen</span></td>
            <td><span>Camping</span></td>
          </tr>
        </thead>
        <tr v-for="region in europa">
          <td><span v-if="region.code" :class="getFlagClass(region.code)"></span> {{region.name}}</td>
          <td>
            <div class="bullet" :class="region.einreise">
              <span class="tooltip">{{region['einreise kommentar']}}</span>
            </div>
          </td>
          <td><span class="bullet" :class="region.einreise"></span></td>
          <td><span class="bullet" :class="region.einreise"></span></td>
          <td><span class="bullet" :class="region.einreise"></span></td>
          <td><span class="bullet" :class="region.einreise"></span></td>
        </tr>
      </table> -->

      <!-- <button v-if="!showAll" v-on:click="showMore()" class="showAllButton">{{showAllMessage}}</button> -->
    </div>
    <p class="footnote"><br>Quelle: F.A.Z. (alle Angaben ohne Gewähr)</p>
  </div>
</template>

<script>
// import {csvParse} from 'd3'
import {TweenLite} from 'gsap'
import {fetchPolyfill} from 'fetch-polyfill'

import toggleItem from './components/toggleItem.vue'

export default {
  name: 'app',
  components: {
    toggleItem
  },
  data () {
    return {
      // dataUrl: 'https://api.y.faz.net/spreadsheets/static/1xHwr6tR6Kg9v9bTmMoa05Xo3NRkvQSlXICQ5-jxCko8.json',
      // dataUrl: 'https://api.y.faz.net/spreadsheets/static/1gSI17EJNWnfceDK0PRpk5xoUdWUCOnKdaQt_mLYmJOI.json',
      dataUrl: null,
      bundeslaender: [],
      europa: [],
      settings: null,
      activeItem: null,
      showAll: false,
      showAllMessage: 'Alle anzeigen',
      maxItems: 9,
      tweenedMaxItems: 9,
      loading: true
    }
  },
  methods: {
    tidyData (data) {
      let array = []
      let header = null

      data.forEach( (row, i) => {
        if (i == 0) {
          header = row
        }
        else {
          let obj = {}
          header.forEach( (colName, i) => {
            obj[colName] = row[i]
          })
          array.push(obj)
        }
      })
      return array
    },
    format (number) {
      return format(",.2r")(number).replace(',','.')
    },
    millions (number) {
      return String(Math.round(number/100000)/10).replace('.',',') + ' Mio.'
    },
    showMore () {
      this.maxItems = this.data.length
      this.showAll = true
    },
    getImgUrl (name) {
      let familyName = name.split(' ').slice(-1)[0]
      return 'https://dynamic.faz.net/red/2019/dem_kandidaten/img/' + familyName + '.jpg'
    },
    toggle (el) {
      el.toggled = !el.toggled
      // this.activeItem = name
    },
    getPolopolyImgUrl (id, derivate) {
      return 'https://www.faz.net/ppmedia/' + id + '/' + derivate
    },
    getFlagClass(countryCode) {
      return 'flag-icon flag-icon-' + countryCode.toLowerCase()
    }
  },
  mounted () {
    this.dataUrl = document.getElementById("spreadsheet-url").dataset.url
    let fetches = [
      fetch(this.dataUrl).then(r => r.text()),
    ]
    Promise.all(fetches).then((results) => {
      console.log( JSON.parse(results[0]).europa )
      this.bundeslaender = this.tidyData(JSON.parse(results[0]).deutschland)
      this.europa = this.tidyData(JSON.parse(results[0]).europa)
      this.settings = this.tidyData(JSON.parse(results[0]).settings)[0]

      this.bundeslaender.forEach(el => {
        this.$set(el, 'toggled', false)
      })
      this.europa.forEach(el => {
        this.$set(el, 'toggled', false)
      })

      this.loading = false
    })
    // console.log(this.data)
  },
  watch: {
    maxItems: function(newValue) {
      TweenLite.to(this.$data, 3, { tweenedMaxItems: newValue });
    }
  },
  computed: {
    // data_filtered () {
    //   return this.data
    //     // .slice(0,this.animatedNumber)
    // },
    animatedNumber: function() {
      return this.tweenedMaxItems.toFixed(0);
    },
  }
}
</script>


<style lang="scss">
@import './assets/reset.scss';
@import './assets/style.scss';
@import './assets/flag-css/flag-icon.scss';
</style>
